import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface PhotoUploadBubbleProps {
  src: string;
  fileName: string;
  size: string;
}
const UPLOAD_MS = 900;

/** Simule le téléversement d'une photo : barre de progression, puis l'aperçu apparaît. */
export function PhotoUploadBubble({
  src,
  fileName,
  size
}: PhotoUploadBubbleProps) {
  const reduceMotion = useReducedMotion();
  const [done, setDone] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setDone(true), reduceMotion ? 0 : UPLOAD_MS);
    return () => window.clearTimeout(timer);
  }, [reduceMotion]);
  return <figure className="w-64 max-w-full overflow-hidden rounded-3xl rounded-br-lg border border-slate-200 bg-white sm:w-72" data-id="element-321" data-mp="1i8oeuvcok82c">
      <div className="relative aspect-[4/3] bg-ville-sand" data-id="element-322" data-mp="2fobx1w6jtfie">
        <motion.img src={src} alt="Photo du problème jointe au signalement" className="h-full w-full object-cover" initial={{
        opacity: 0
      }} animate={{
        opacity: done ? 1 : 0.35
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-323" data-mp="2fpwvvxzwbkm2" />
        {!done && <div className="absolute inset-x-4 bottom-4 h-1.5 overflow-hidden rounded-full bg-white/70" data-id="element-324" data-mp="2yvozu0a9n5p">
            <motion.div className="h-full rounded-full bg-ville-navy" initial={{
          width: '8%'
        }} animate={{
          width: '100%'
        }} transition={{
          duration: UPLOAD_MS / 1000,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-325" data-mp="7worod2dnz18" />
          </div>}
      </div>
      <figcaption className="flex items-center justify-between gap-3 px-4 py-2.5 text-xs" data-id="element-326" data-mp="3g5p037g9h4m3">
        <span className="min-w-0 truncate font-semibold text-ville-navy" data-id="element-327" data-mp="3l3gpnutfoen4">{fileName}</span>
        <span className="flex shrink-0 items-center gap-1 font-semibold text-slate-500" aria-live="polite" data-id="element-328" data-mp="1edsf7787eien">
          {done ? <>
              <CheckIcon className="h-3.5 w-3.5 text-emerald-600" aria-hidden="true" data-id="element-329" data-mp="1jc3nvemrimva" />
              {size}
            </> : 'Téléversement…'}
        </span>
      </figcaption>
    </figure>;
}